import axios, { AxiosError } from "axios";
import worker from "../setupWorker";
import { getCurrentDate, getEndOfWeek, getStartOfWeek } from "../utils/DateTimeUtilsTs";
import { dateToDateString } from "../utils/DateTimeUtils";
export let IdTokenGlobal = ''
function processAxioError(error: any) {
    if (axios.isAxiosError(error)) {
        console.error("❌ Lỗi khi đăng nhập:", error.response ? error.response.data : error.message);
        worker.postMessage({ type: 'showsnackbar', data: error.response ? (error.response.data.message) : error.message })
    }
    else
        throw error
}
export function setIdTokenGlobal(newIdToken: string) {
    IdTokenGlobal = newIdToken;
}
export const OneAPi = {
    login: async (username: string, password: string) => {
        const url = "https://id.lotusapi.com/auth/sign-in";
        const payload = {
            Username: username,
            Password: password
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            IdTokenGlobal = response.data.IdToken;
            return response.data;
        } catch (error: any) {
            processAxioError(error);
        }

    },
    confirm: async (Username: string, Session: string, Code: string) => {
        const url = "https://id.lotusapi.com/auth/confirm-sign-in";
        const payload = {
            Username: Username,
            Session: Session,
            Code: Code
        };

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            IdTokenGlobal = response.data.IdToken;
            return response.data;
        } catch (error: any) {
            processAxioError(error);
        }

    },
    profile: async () => {
        const checkToken = await OneAPi.checkToken(IdTokenGlobal)
        if (!checkToken) {
            return;
        }
        const url = "https://id.lotusapi.com/users/profile";

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${IdTokenGlobal}`
                }
            });


            return response.data;
        } catch (error: any) {

            processAxioError(error);
        }

    },
    price: async (payload: any) => {
        if (!OneAPi.checkToken(IdTokenGlobal)) {
            return;
        }
        const { gameType, betType } = payload;
        const url = `https://lotto.lotusapi.com/odds/public?gameTypes=${gameType}&betTypes=${betType}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${IdTokenGlobal}`
                }
            });


            return response.data;
        } catch (error: any) {

            processAxioError(error);
        }

    },
    recentBets: async () => {
        if (!OneAPi.checkToken(IdTokenGlobal)) {
            return;
        }
        const url = `https://lotto.lotusapi.com/game-play/player/tickets/current?limit=100`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${IdTokenGlobal}`
                }
            });


            return response.data;
        } catch (error: any) {

            processAxioError(error);
        }

    },
    statements: async () => {
        if (!OneAPi.checkToken(IdTokenGlobal)) {
            return;
        }
        const curDate = getCurrentDate();
        const fromDate = dateToDateString(getStartOfWeek(curDate));
        const toDate = dateToDateString(getEndOfWeek(curDate)) ;
        
        const url = `https://report.lotusapi.com/statements/player/statements/production-date?` +
            `from=${fromDate}&to=${toDate}`
            + `&productTypes=0&productTypes=1&productTypes=2&productTypes=100&productTypes=101`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${IdTokenGlobal}`
                }
            });


            return response.data;
        } catch (error: any) {

            processAxioError(error);
        }

    },
    play: async (payload: any) => {
        if (!OneAPi.checkToken(IdTokenGlobal)) {
            return;
        }
        const url = `https://lotto.lotusapi.com/game-play/player/play`;

        try {
            const response = await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${IdTokenGlobal}`
                }
            });


            return response.data;
        } catch (error: any) {

            processAxioError(error);
        }

    },
    checkToken: async (IdToken: string): Promise<boolean> => {
        if (IdToken == '') {
            worker.postMessage({ type: 'showsnackbar', data: 'Bạn hãy đăng nhập lại One789' })
            return false;

        }
        return true;
    }
}